angular.module('rjmNg.api').factory 'Invites', [
  "$resource"
  "serviceUrl"
  (
    $resource
    serviceUrl
  ) ->

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    actionUrls =
      redeemInvite: serviceUrl("/v3/invites/redeem/:token")
      createInvite: serviceUrl("/v3/invites/")

    actions =
      getRedemption: angular.extend {}, defaultParams,
        method: "GET"
        url: actionUrls.redeemInvite
      redeemInvite: angular.extend {}, defaultParams,
        method: "PUT"
        url: actionUrls.redeemInvite
        token: "@token"
      createInvite: angular.extend {}, defaultParams,
        method: "POST"
        url: actionUrls.createInvite

    invites = $resource serviceUrl("/v3/invites/"), {}, actions

    getRedemption: (token) ->
      invites.getRedemption({token}).$promise

    redeemInvite: (token, data) ->
      invites.redeemInvite({token}, data).$promise

    ###
    data = {
      email: string
      client_id: number
      client_rights: {
        admin: 0 or 1
        billing: 0 or 1
        readonly: 0 or 1
        technical: 0 or 1
      }
    }
    ###
    createInvite: (data) ->
      invites.createInvite(data).$promise
]
